import { useEffect, useRef, useState } from "react";

const VIEWPORT_WIDTH = 1260;
const VIEWPORT_HEIGHT = 725;
const SHADOW = "0 16px 40px oklch(0.12 0.008 75 / 0.08)";
const SRC = `/workflows-demo-animation.html?v=${Date.now()}`;

const WorkflowsDemoEmbed = ({ active }: { active: boolean }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const update = () => {
      if (containerRef.current) {
        setScale(containerRef.current.clientWidth / VIEWPORT_WIDTH);
      }
    };
    update();
    const ro = new ResizeObserver(update);
    if (containerRef.current) ro.observe(containerRef.current);
    return () => ro.disconnect();
  }, []);

  const src = active ? SRC : "";

  return (
    <div
      ref={containerRef}
      style={{
        width: "100%",
        height: `${VIEWPORT_HEIGHT * scale}px`,
        overflow: "hidden",
        borderRadius: "20px",
        background: "oklch(var(--surface-panel))",
        border: "1.5px solid oklch(var(--border))",
        boxShadow: SHADOW,
      }}
    >
      <iframe
        title="Workflows demo animation"
        src={src}
        tabIndex={-1}
        style={{
          display: "block",
          border: 0,
          background: "transparent",
          width: `${VIEWPORT_WIDTH}px`,
          height: `${VIEWPORT_HEIGHT}px`,
          transform: `scale(${scale})`,
          transformOrigin: "top left",
          pointerEvents: "none",
        }}
      />
    </div>
  );
};

export default WorkflowsDemoEmbed;
